<template>
    <div id="ProfileInfo">
        <div class="ProfileArea d-flex justify-content-between">
            <div class="d-flex pictureAndName">
                <div class="picture">
                    <img :src="UserInfo.pictureUrl" alt="Alternate Text" />
                </div>
                <div>
                    <div class="name">
                        {{UserInfo.fullName}}
                    </div>
                    <div class="deptname">
                        {{UserInfo.deptName}}
                    </div>
                </div>
            </div>
            <div class="tool d-flex align-items-center">
                <div>
                    <img width="20" height="20" src="../assets/Bell.png" />
                </div>
                <div>
                    <img width="20" height="20" src="../assets/More.png" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                UserInfo:''
            }
        },
        mounted() {
            let storage = JSON.parse(localStorage.getItem("UserInfo"));
            this.UserInfo = storage
        }
    }
</script>
<style scoped>
    #ProfileInfo {
        padding: 26px 30px;
        border-bottom: 1px solid #33363D;
    }

        #ProfileInfo .tool div {
            margin: 0 10px;
        }
    #ProfileInfo .ProfileArea .pictureAndName {
        width: 170px;
        height: 60px;
        align-items: center;
    }

        #ProfileInfo .ProfileArea .picture{
            margin-right:20px;
        }
        #ProfileInfo .ProfileArea .name {
            color: #FCFCFC;
        }

    #ProfileInfo .ProfileArea .deptname {
        color: #6C6B6B;
    }

    #ProfileInfo .picture {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #FB8546;
        overflow: hidden;
        padding: 1px;
    }
        #ProfileInfo .picture img {
            width: 100% ;
            padding: 2px;
            border-radius: 50%;
        }
</style>